module.exports = __webpack_public_path__ + "img/icon-differentials_08.bf7a0a23.svg";